import apiService from './ApiService';

const GptClasicoReportsService = {
  /**
   * Obtiene mensajes guardados en BD para un asistente IA.
   * @param {string} idOpenAIAssistant
   * @param {{pagina?:number,tamañoPagina?:number,limiteMensajesPorThread?:number,texto?:string,fechaDesde?:string,fechaHasta?:string,filtroRol?:string}} options
   */
  async getReportes(idOpenAIAssistant, options = {}) {
    if (!idOpenAIAssistant) throw new Error('Falta el ID del asistente');
    const params = new URLSearchParams();
    params.append('pagina', options.pagina ?? 1);
    params.append('tamañoPagina', Math.min(options.tamañoPagina ?? 300, 300));
    params.append('limiteMensajesPorThread', Math.min(options.limiteMensajesPorThread ?? 200, 500));
    params.append('filtroRol', options.filtroRol || 'user');
    if (options.texto) params.append('texto', options.texto);
    if (options.fechaDesde) params.append('fechaDesde', options.fechaDesde);
    if (options.fechaHasta) params.append('fechaHasta', options.fechaHasta);
    const response = await apiService.get(`/asistente/${idOpenAIAssistant}/reportes?${params.toString()}`);
    if (response && response.ok === false) {
      const msg = response.message || response.error || 'No se pudieron obtener los mensajes';
      throw new Error(msg);
    }
    return response;
  }
};

export default GptClasicoReportsService;
